import { BoxProps } from '@chakra-ui/react';
import { BaseChartImage } from './BaseChartImage';

export const DownturnChart = (props: BoxProps) => (
    <BaseChartImage {...props}>
        <svg width="90" height="85" viewBox="0 0 90 85" fill="none">
            <path
                d="M1 1L16 11L18.5 20L26.5 27.5L38 32.5V41L45.5 45L50 53.5H55.5L60 66L69 69.5L74 66L82.5 73.5L89 84.5"
                stroke="#FF7272"
                strokeWidth="1.5"
            />
        </svg>
    </BaseChartImage>
);
